import UtilService from "@/services/UtilService";

export default class WorkingHours {
  workingHoursId!: number;
  startTime!: string;
  endTime!: string;
  restaurantId!: number;
  workingHoursName!: string;

  constructor(jsonObj?: WorkingHours) {
    if (jsonObj) {
      WorkingHours.update(this, jsonObj);
    }
  }

  static update(toUpdate: WorkingHours, newValues: WorkingHours) {
    if (newValues && toUpdate) {
      toUpdate.workingHoursId = newValues.workingHoursId;
      toUpdate.startTime = newValues.startTime;
      toUpdate.endTime = newValues.endTime;
      toUpdate.restaurantId = newValues.restaurantId;
      toUpdate.workingHoursName = newValues.workingHoursName;
    }
  }

  static copy(workingHoursToCopy: WorkingHours): WorkingHours {
    return new WorkingHours(JSON.parse(JSON.stringify(workingHoursToCopy)));
  }

  static haveDifferences(wh1: WorkingHours, wh2: WorkingHours): boolean {
    return !UtilService.equals(wh1, wh2);
  }

  static WorkingHoursByStartTimeAscendingComparator = (
    wh1: WorkingHours,
    wh2: WorkingHours
  ) => {
    const name1 = wh1.startTime;
    const name2 = wh2.startTime;
    return UtilService.stringComparatorAscending(name1, name2);
  };

  static getPossibleTimes(interval: number) {}
}
